export default __webpack_public_path__ + "static/media/eyesight.a4e53f3e.jpg";